import { Navigate, useParams } from "react-router";

/**
 * Redirect a wildcard child route to its resource's default tab.
 *
 * A `<Route path="*">` nested under a parent that has a path forms a
 * multi-segment splat — `/sessions/:sessionId/*`. Since React Router v7, a
 * *relative* target inside such a route resolves against the full matched
 * path including the splat, so `<Navigate to="topics">` from
 * `/sessions/abc/badtab` lands on `/sessions/abc/badtab/topics`. That matches
 * the wildcard again and redirects again, forever.
 *
 * Building an absolute path from the route params sidesteps the relative
 * resolution entirely, and stays correct however deep the unknown path was.
 */
export function RedirectToDefaultTab({
  buildPath,
}: {
  buildPath: (params: Readonly<Record<string, string | undefined>>) => string;
}) {
  const params = useParams();
  return <Navigate to={buildPath(params)} replace />;
}
